/**
 * Labstep
 *
 * @module core/FullCalendar
 * @desc Imports (lazy) fullCalendar in error boundary
 */

import { ErrorBoundaryContainer } from 'labstep-web/containers/ErrorBoundary';
import React, { forwardRef, Suspense } from 'react';
import type { IFullCalendarProps } from './types';

export const FullCalendarComponent = React.lazy(() =>
  import('labstep-web/core/FullCalendar/component').then(
    (module) => ({
      default: module.FullCalendarComponent,
    }),
  ),
);

export const FullCalendar: React.FC<IFullCalendarProps> = forwardRef(
  (props, ref) => (
    <ErrorBoundaryContainer FallbackComponent={<div />}>
      <Suspense fallback={<div />}>
        <FullCalendarComponent ref={ref} {...props} />
      </Suspense>
    </ErrorBoundaryContainer>
  ),
);
